<script setup>
const props = defineProps({
  color: {
    type: String,
    default: "#111932",
  },
});
</script>

<template>
  <div>
    <img
      src="/assets/images/shared/logo-1.png"
      alt="Application Logo"
      class="application-logo application-logo-dark"
    />
    <img
      src="/assets/images/shared/logo-2.png"
      alt="Application Logo"
      class="application-logo application-logo-light"
    />
  </div>
</template>

<style scoped>
.application-logo {
  display: block;
  width: 160px;
  height: 48px;
}

html.dark .application-logo-light {
  display: none;
}

html:not(.dark) .application-logo-dark {
  display: none;
}
</style>
